import { render, staticRenderFns } from "./UnsubscribeBaremetal.vue?vue&type=template&id=15882fec"
import script from "./UnsubscribeBaremetal.vue?vue&type=script&lang=js"
export * from "./UnsubscribeBaremetal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports